import React from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";
const Modal = ({ label, isOpen, onClose, children, width = "w-[410px]" }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-50 z-[9998]"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="fixed inset-0 flex justify-center items-center z-[9999]">
        <div
          className={`relative bg-white rounded-lg shadow-lg max-w-full ${width} max-h-[90vh] overflow-hidden`}
          onClick={(e) => e.stopPropagation()}
        >
          {label && (
            <div className="absolute top-4 left-4 flex justify-between items-center pb-1">
              <h2 className="text-lg font-bold text-custom-blue">{label}</h2>
            </div>
          )}
          {onClose && (
            <button
              className="absolute top-2 right-2 p-2 rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 transition"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          )}

          {label && <div className="border-t-2 mt-12"></div>}

          {/* Make this scrollable */}
          <div className="px-6 py-2 overflow-y-auto max-h-[calc(90vh-4rem)]">
            {children}
          </div>
        </div>
      </div>
    </>,
    document.body // Mount modal outside of normal component tree
  );
};

export default Modal;
